import React from "react"
import { useSearchParams } from "react-router-dom"
import { useTranslation } from "react-i18next"
import DSTab from "ui/DSTab"
import { Discounts } from "./Discounts"
// import { Vouchers } from "./Vouchers" — will be implemented later
import styles from "./index.module.css"

const TAB_KEYS = {
  DISCOUNTS: "discounts"
  // VOUCHERS: "vouchers" — commented out, will be implemented later
}

export const PricingPromotions = () => {
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()
  const activeTab = searchParams.get("tab") || TAB_KEYS.DISCOUNTS
  const setActiveTab = (key) => setSearchParams({ tab: key }, { replace: true })

  const TAB_ITEMS = [
    { key: TAB_KEYS.DISCOUNTS, label: t("settings.tab_discounts") }
    // { key: TAB_KEYS.VOUCHERS, label: t("settings.tab_vouchers") } — commented out, will be implemented later
  ]

  return (
    <>
      <DSTab items={TAB_ITEMS} activeKey={activeTab} onChange={setActiveTab} className={styles.tabContainer} />
      {activeTab === TAB_KEYS.DISCOUNTS && <Discounts />}
    </>
  )
}
